// src/portals/AthletePortal.jsx

import React from 'react';
import DashboardView from '../components/DashboardView';
import FamilyHuddleView from '../components/FamilyHuddleView';
import KidzCorner from '../components/KidzCorner';
import TopicView from '../components/TopicView';
import { isCustomId } from '../utils/customNav';
import Performance123View from '../components/Performance123View';
import BrainHealthView from '../components/BrainHealthView';
import LeadershipHubView from '../components/LeadershipHubView'; // <-- NEW IMPORT
import RechargeHub from '../components/RechargeHub';
import JournalView from '../components/JournalView';
import FinanceHubView from '../components/finance/FinanceHubView';
import { initialTopicContent } from '../data/content';

const AthletePortal = ({ activeTab, handleNavigate, currentUser, handleAiTrigger }) => {
    switch (activeTab) {
        case 'dashboard': 
        case 'assessment': 
        case 'pulse': 
            return <DashboardView onNavigate={handleNavigate} currentUser={currentUser} />;
        case 'reset-recharge':
            return <RechargeHub currentUser={currentUser} onNavigate={handleNavigate} />;
        case 'journal':
            return <JournalView currentUser={currentUser} onNavigate={handleNavigate} />;
        case 'family-huddle': 
            return <FamilyHuddleView />;
        case 'kidzcorner': 
            return <KidzCorner contentData={initialTopicContent} currentUser={currentUser} />;
        case 'performance-123': 
            return <Performance123View />;
        case 'brain-health':
            return <BrainHealthView />;
        case 'finance':
            return <FinanceHubView currentUser={currentUser} />;
        case 'leadership': // <-- NEW ROUTE
            return <LeadershipHubView onAskAi={handleAiTrigger} />;
        case 'transition': 
            return <TopicView topicId="transition" onAskAi={handleAiTrigger} currentUser={currentUser} />;
        default:
            let topicId = activeTab;
            if (activeTab === 'mental-health') topicId = 'anxiety';
            if (activeTab === 'mental-performance') topicId = 'resilience';

            // An org-defined topic (utils/customNav.js) has no hardcoded content;
            // its page is fed from the org's private_topics. App.jsx has already
            // checked the org still lists it, so any custom id reaching here is allowed.
            if (initialTopicContent[topicId] || activeTab.includes('mental-') || initialTopicContent[activeTab] || isCustomId(activeTab)) {
                return <TopicView topicId={topicId} contentData={initialTopicContent} onAskAi={handleAiTrigger} currentUser={currentUser} />;
            }
            // Fallback to Dashboard
            return <DashboardView onNavigate={handleNavigate} currentUser={currentUser} />;
    }
};

export default AthletePortal;